module.exports = __webpack_public_path__ + "img/goddyns-1.9d84e35.jpg";